export const defaultState = () => {
    return {
        uploaded: false,
        queued: true,
        lastUploadDate: null,
        queueStartedAt: new Date().toISOString(),
        upload: 0,
        track: 0,
        sequences: {},
        globalSequence: 1,
        serverIsAvailable: false
    }
}

const state = defaultState()
export default state
